export const STARTING_PROGRESS = 0.01;
